var currentPageLink = window.location.href;
var currentDate = new Date();
var comparisonTodayDate = currentDate.toISOString().split("T")[0];
if (typeof collection_expiry !== "undefined")
{
  var collection_expiry_endofday = new Date(collection_expiry+'T23:59:59.999');
}
else
{
  var collection_expiry_endofday = currentDate;
}
collection_expiry_endofday = collection_expiry_endofday.toUTCString();
if (currentPageLink?.includes("team-store")) {
  if (checkACookieExists("team_store")) {
    if (
      typeof collection_id !== "undefined" &&
      typeof collection_expiry !== "undefined" &&
      typeof collection_colorstring !== "undefined" &&
      typeof collection_productids !== "undefined"  &&
      typeof collection_productcolorstring !== "undefined"
    ) {
      if (collection_expiry < comparisonTodayDate) 
      {
        clearTeamStoreCookies();
      } 
      else 
      {
        createTeamStoreCookies();
      }
    }
  } else {
    if (
      typeof collection_id !== "undefined" &&
      typeof collection_expiry !== "undefined" &&
      typeof collection_colorstring !== "undefined" &&
      typeof collection_productids !== "undefined" &&
      typeof collection_productcolorstring !== "undefined"
    ) 
    {
      if (collection_expiry >= comparisonTodayDate) 
      {
        createTeamStoreCookies();
      }
    }
  }
}

function createTeamStoreCookies()
{
  document.cookie = "team_store=" + collection_id + "; expires="+collection_expiry_endofday+"; path=/";
  document.cookie = "team_colors=" + collection_colorstring + "; expires="+collection_expiry_endofday+"; path=/";
  document.cookie = "team_products=" + collection_productids + "; expires="+collection_expiry_endofday+"; path=/";
  document.cookie = "team_productcolors=" + collection_productcolorstring + "; expires="+collection_expiry_endofday+"; path=/";
}

function clearTeamStoreCookies()
{
  document.cookie = "team_store=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
  document.cookie = "team_colors=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
  document.cookie = "team_products=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
  document.cookie = "team_productcolors=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
}

function checkACookieExists(cookie_name) {
  if (
    document.cookie
      .split(";")
      .some((item) => item.trim().startsWith(cookie_name + "="))
  ) {
    return true;
  }
  return false;
}